import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net-bs5';
import "datatables.net-responsive/js/dataTables.responsive.min.js";

function StaffTable({ staff }) {
    const tableRef = useRef(null);
    const dataTableRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!staff || staff.length === 0) return;

        const $table = $(tableRef.current);

        if (dataTableRef.current) {
            dataTableRef.current.destroy();
            $table.empty();
            dataTableRef.current = null;
        }

        dataTableRef.current = $table.DataTable({
            responsive: true,
            colReorder: true,
            data: staff,
            columns: [
                {
                    data: null,
                    render: (data, type, row, meta) => meta.row + 1,
                    title: "SN"
                },
                {
                    data: 'name',
                    title: "Staff Name",
                    render: (data) => `
                        <div class="d-flex align-items-center text-body-emphasis">
                            <div class="avatar avatar-m"><img class="rounded-circle"
                                src="/assets/img/team/default-avatar.png" alt="" /></div>
                            <p class="mb-0 ms-3 text-body-emphasis fw-bold">
                                ${data}
                            </p>
                        </div>
                    `
                },
                {
                    data: 'roleId.name',
                    title: "Role",
                    defaultContent: '-----',
                    render: (data) => `<span class="badge badge-phoenix badge-phoenix-primary ms-2">${data}</span>`
                },
                {
                    data: 'email',
                    title: "Email"
                },
                // {
                //     data: 'telegramId',
                //     title: "Telegram ID",
                //     defaultContent: '-----',
                //     render: (data) => data ? `<span class="badge badge-phoenix badge-phoenix-info">${data}</span>` : '-----'
                // },
                {
                    data: 'createdAt',
                    title: "Created At",
                    render: (data) => new Date(data).toLocaleDateString('en-IN', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                    })
                },
                {
                    data: '_id',
                    title: "Action",
                    className: 'text-end',
                    orderable: false,
                    render: (data) => `<button class="btn btn-sm btn-soft-info me-1 view-btn" data-id="${data}">
                        <i class="fas fa-eye"></i> View
                    </button>`
                }
            ],
            layout: {
                bottomEnd: {
                    paging: {
                        firstLast: false
                    }
                }
            }
        });

        // Handle view button click
        $(tableRef.current).on('click', '.view-btn', function() {
            const id = $(this).data('id');
            navigate(`/staff/${id}`);
        });

        return () => {
            if (dataTableRef.current) {
                dataTableRef.current.destroy();
                dataTableRef.current = null;
            }
            if (tableRef.current) {
                $(tableRef.current).off('click', '.view-btn');
            }
        };
    }, [staff, navigate]);

    if (!staff || staff.length === 0) {
        return <p>No staff found.</p>;
    }

    return (
        <div className="table-responsive">
            <table
                ref={tableRef}
                className="table table-bordered table-hover table-sm display responsive nowrap"
                id="staffTable"
                style={{ width: '100%' }}
            >
            </table>
        </div>
    );
}

export default StaffTable;
